import { createStyles, makeStyles } from '@material-ui/core';

const useStyles = makeStyles((theme) =>
  createStyles({
    container: {
      [theme.breakpoints.down('sm')]: {
        marginTop: 10,
      },
      [theme.breakpoints.down('xs')]: {
        marginTop: 5,
      },
      marginBottom: 50,
      bottom: 85,
      maxWidth: 680,
      width: '100%',
      padding: '0px!important',
    },
    iconRoquinha: {
      width: 50,
      height: 50,
      marginBottom: 20,
    },
    iconHumburguer: {
      width: 50,
      height: 50,
      marginBottom: -40,
    },
    iconSushi: {
      width: 50,
      height: 50,
      marginBottom: 20,
    },
  }),
);

export default useStyles;
